import styled from '@emotion/styled';
import Chip from '@zola/zola-ui/src/components/Chip';
import { FilterPill } from '@zola/zola-ui/src/components/FilterPill';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';

export const FilterRow = styled.div<{ isCompact: boolean }>`
  align-items: center;
  width: 100%;
  gap: ${SPACING.XS};

  display: flex;
  white-space: normal;

  &::-webkit-scrollbar {
    display: none;
  }

  flex-wrap: ${props => (props.isCompact ? 'nowrap' : 'wrap')};
  white-space: ${props => (props.isCompact ? 'nowrap' : 'normal')};

  .dropdown {
    white-space: normal !important;
  }
`;

export const FilterChip = styled(Chip)`
  background-color: ${COLORS3.BLACK_005};
  flex: 0 0 auto;
  font-size: ${FONTS.SIZE.SMALLER};
  white-space: nowrap;
  border: none;

  ${props =>
    (props.active || props.selected) &&
    `
    background-color: ${COLORS3.BLACK_015};
  `}

  &:hover {
    background-color: ${COLORS3.BLACK_015};
  }
`;

export const StyledFilterPill = styled(FilterPill)`
  margin: 0;
`;
